// @flow

export function addToCartPetsdeli (customerId: string, subscriberId: string, productId: string): Promise<any> {
  return window.cartApi.addProduct(productId, 1)
}
